/*
  Finish control.

  Two jobs:
  1. The heading reads "Finish: Gold" and previews whichever chip is hovered or
     focused, restoring the real selection on leave.
  2. Choosing the other finish swaps the product in place instead of loading a
     new page.

  Gold and silver are separate products here rather than variants of one, so
  the swap is done through Shopify's Section Rendering API: the sibling's
  product section is fetched and its markup replaces the current one. That
  keeps price, media, options and the add-to-cart form server-rendered and
  correct, with no duplicated client-side product state.

  The chips stay real links, so without JavaScript — and for crawlers and
  open-in-new-tab — they still work as ordinary navigation.
*/
(function () {
  'use strict';

  var busy = false;

  /* ---------- heading preview ---------- */

  function labelIn(scope) {
    return scope.querySelector('[data-finish-current]');
  }

  function preview(opt) {
    var group = opt.closest('.ppdp__finish');
    if (!group) return;
    var el = labelIn(group);
    var name = opt.getAttribute('data-finish-name');
    if (el && name) el.textContent = name;
  }

  function restore(opt) {
    var group = opt.closest('.ppdp__finish');
    if (!group) return;
    var el = labelIn(group);
    if (el) el.textContent = el.getAttribute('data-finish-selected') || el.textContent;
  }

  ['mouseenter', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var opt = e.target.closest && e.target.closest('.ppdp__finish-opt');
      if (opt) preview(opt);
    }, true);
  });

  ['mouseleave', 'focusout'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var opt = e.target.closest && e.target.closest('.ppdp__finish-opt');
      if (opt) restore(opt);
    }, true);
  });

  /* ---------- in-place swap ---------- */

  function sectionOf(el) {
    return el.closest('[id^="shopify-section-"]');
  }

  function swap(url, section, push) {
    busy = true;
    section.setAttribute('aria-busy', 'true');
    section.classList.add('is-swapping');

    // The sibling lives on its own template, so its section id differs from
    // this page's — requesting ?section_id= with the current id 404s. Fetching
    // the product URL and lifting its main section out avoids depending on an
    // id this page cannot know.
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh =
          doc.querySelector('[id^="shopify-section-"][id$="__main"]') ||
          (doc.querySelector('[data-ppdp]') || {}).closest
            ? doc.querySelector('[data-ppdp]').closest('[id^="shopify-section-"]')
            : null;
        if (!fresh) throw new Error('no product section in response');

        section.innerHTML = fresh.innerHTML;

        if (push) window.history.pushState({ finishSwap: true }, '', url);

        var title = doc.querySelector('title');
        if (title) document.title = title.textContent;

        // persona-pdp.js re-initialises on this, so the gallery, options,
        // engraving preview and add-to-cart all rebind to the new markup.
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            detail: { sectionId: section.id.replace('shopify-section-', '') }
          })
        );
      })
      .catch(function () {
        // Never strand the shopper: fall back to a normal page load.
        window.location.href = url;
      })
      .then(function () {
        busy = false;
        section.removeAttribute('aria-busy');
        section.classList.remove('is-swapping');
      });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.ppdp__finish-opt');
    if (!opt) return;
    if (opt.classList.contains('is-current')) { e.preventDefault(); return; }
    // Let modified clicks open the plain URL in a new tab.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    var section = sectionOf(opt);
    var href = opt.getAttribute('href');
    if (!section || !href) return;

    e.preventDefault();
    if (busy) return;
    swap(href, section, true);
  });

  window.addEventListener('popstate', function () {
    var section = document.querySelector('[id^="shopify-section-"] [data-ppdp]');
    if (!section) return;
    swap(window.location.pathname, sectionOf(section), false);
  });
})();
